import script from "./ConfigNotificationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigNotificationsSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigNotificationsSection.vue?vue&type=style&index=0&id=46ebfca1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ebfca1"]])

export default __exports__